import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BottomMenuService {

  activeButtonWaiterSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public activeButtonWaiter$: Observable<boolean> = this.activeButtonWaiterSubject.asObservable();

  constructor() { }
}
